import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Stack, Typography } from "@mui/material";

import { border } from "../styles";

interface PickerHeaderProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
}

export const PickerHeader: React.FC<PickerHeaderProps> = ({ title, subtitle, onClose }) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: "20px", py: "16px" }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ borderBottom: border(), width: "100%", pb: subtitle ? "0px" : "6px" }}
      >
        <Stack direction="column" alignItems="flex-start">
          <Typography sx={{ fontSize: 18, fontWeight: 400, color: "#071F35" }}>{title}</Typography>
          {subtitle && <Typography sx={{ fontSize: 14, color: "#496682" }}>{subtitle}</Typography>}
        </Stack>
        <IconButton onClick={onClose} size="sm" aria-label="Close">
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Stack>
    </Stack>
  );
};
